import { orderBy } from 'natural-orderby';
import React, { useEffect, useState } from 'react';
import placeholderImage from '../../../assets/images/placeholder.jpg';
import AssociateSidebar from '../AssociateSidebar';

import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
import { GET, newFetch } from '../../../helpers/fetch';
const { API_URL, SERVER_URL } = config;

const Associates = ({
  sites,
  activeShift,
  activeDate,
  activeSchedules,
  activeClient,
  activeSite,
  activeWeek,
  associates,
  gettingData,
  fetchSchedules,
  assocCheckedItems,
  setAssocCheckedItems,
  activeStatus,
  siteAssociateLeaves,
  sidebarMultiAssocLeaves,
  setSidebarMultiAssocLeaves,
}) => {
  const token = localStorage.getItem('token');

  const [activeSidebar, setActiveSidebar] = useState(false);
  const [sidebarMultiAssoc, setSidebarMultiAssoc] = useState(false);
  const [sortedAssociates, setSortedAssociates] = useState([]);
  const [associate, setAssociate] = useState({});
  const [activeSchedule, setActiveSchedule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statuses, setStatuses] = useState([]);
  const [assocToEdit, setAssocToEdit] = useState([]);
  const noEditButton = ['Not Available', 'Extension', 'Preferred'];

  const [selectedAssociate, setSelectedAssociate] = useState([]);

  //pull attendance status
  const fetchStatuses = async () => {
    let api_path = `/attendanceStatus`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatuses(response.data);
    }
  };

  useEffect(() => {
    if (associates && associates.length > 0) {
      let sorted = orderBy(associates, [
        (associate) => `${associate.first_name} ${associate.last_name}`,
      ]);
      setSortedAssociates(sorted);
    } else {
      setSortedAssociates([]);
    }
  }, [associates]);

  const sidebarHandler = async (associate_id) => {
    await fetchAssociate(associate_id);
    const selectedAssociate = sortedAssociates.filter((associate) => {
      return associate.id === associate_id;
    });
    setSelectedAssociate(selectedAssociate?.[0] || []);

    setActiveSidebar(true);
    setSidebarMultiAssoc(false);
  };

  //update multiple associates
  const editMultipleAssocStatus = async () => {
    if (assocCheckedItems.length == 0) {
      ToastUtil.error('Please choose one or more employee.');
      return false;
    }
    if (assocCheckedItems.length == 1) {
      await fetchAssociate(assocCheckedItems[0]);
      setActiveSidebar(true);
    } else {
      // return the ones with equal id
      let result = sortedAssociates.filter(function (o1) {
        return assocCheckedItems.some(function (o2) {
          return o1.id === o2;
        });
      });
      setAssocToEdit(result);
      setSidebarMultiAssoc(true);
    }

    if (!statuses.length > 0) {
      await fetchStatuses();
    }
  };

  const checkItem = async (isToggled, id) => {
    let items = [...assocCheckedItems];

    if (isToggled) {
      items = [...items, id];
    } else {
      items = [...items.filter((item) => item !== id)];
    }
    setSidebarMultiAssoc(false);
    setActiveSidebar(false);
    setAssocCheckedItems(items);
  };

  const fetchAssociate = async (id) => {
    let url = `${API_URL}/associate/${id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setAssociate(data.data);
      } else {
        console.log('Failed to fetch employees');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeSchedules.length > 0) {
      let currentSchedule = activeSchedules.find(
        (schedule) => schedule.shift_id === activeShift
      );
      setActiveSchedule(currentSchedule);
    } else {
      setActiveSchedule(null);
    }
  }, [activeSchedules, activeShift]);

  // render
  const body =
    sortedAssociates.length > 0 && gettingData == false ? (
      <div className="d-flex flex-column pb-3 pt-5">
        <div className="pb-4">
          <div className="row align-items-center">
            <div className="col-6">
              <strong>
                Fixed Schedule (
                {
                  sortedAssociates.filter(
                    (associate) => associate.is_team_support
                  ).length
                }
                )
              </strong>
            </div>
            <div className="col-6 pe-4 text-end">
              {!noEditButton.includes(activeStatus) ? (
                <button
                  type="button"
                  disabled={false}
                  className="col btn btn-outline-brand adjust-btn-manageshifts"
                  style={{ width: 150 }}
                  onClick={() => editMultipleAssocStatus()}
                >
                  Edit
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="row px-4 pt-2">
            {sortedAssociates
              .filter((associate) => associate.is_team_support)
              .map((associate, index) => (
                <div
                  key={index}
                  className="user-associate col-sm-3 pb-2 align-items-center"
                >
                  <div
                    className="form-check form-check-inline"
                    style={
                      noEditButton.includes(activeStatus)
                        ? {
                            display: 'none',
                          }
                        : {}
                    }
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="assocCheckbox"
                      checked={assocCheckedItems.includes(associate.id)}
                      onChange={(e) =>
                        checkItem(e.target.checked, associate.id)
                      }
                    />
                  </div>
                  <div onClick={() => sidebarHandler(associate.id)}>
                    <img
                      className="rounded-circle border me-3"
                      style={{ width: '45px', height: '45px' }}
                      src={
                        associate.image
                          ? `${SERVER_URL}/${associate.image}`
                          : placeholderImage
                      }
                      alt="username-img"
                    />
                    <div>
                      <span>h</span>
                    </div>
                  </div>
                  <div onClick={() => sidebarHandler(associate.id)}>
                    <p className="fs-6 fw-medium">
                      {associate.last_name_first
                        ? `${associate.last_name} ${associate.first_name}`
                        : `${associate.first_name} ${associate.last_name}`}

                      {(associate.is_overtime_before ||
                        associate.is_overtime_after) && (
                        <>
                          <br />
                          <small className="text-primary">
                            <u>
                              {associate.is_overtime_before &&
                              associate.is_overtime_after
                                ? 'Overtime Before & After'
                                : associate.is_overtime_before
                                ? 'Overtime Before'
                                : 'Overtime After'}
                            </u>
                          </small>
                        </>
                      )}

                      {associate.is_undertime && (
                        <>
                          <br />
                          <small className="text-danger">
                            <u>Undertime</u>
                          </small>
                        </>
                      )}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div>
          <div className="pt-4 pb-5">
            <strong>
              Flexi Schedule (
              {
                sortedAssociates.filter(
                  (associate) => !associate.is_team_support
                ).length
              }
              )
            </strong>
            <div className="row px-4 pt-2">
              {sortedAssociates
                .filter((associate) => !associate.is_team_support)
                .map((associate, index) => (
                  <div
                    key={index}
                    className="non-team-support col-sm-3 d-flex align-items-center justify-content-center"
                  >
                    <div
                      className="form-check form-check-inline"
                      style={
                        noEditButton.includes(activeStatus)
                          ? { display: 'none' }
                          : {}
                      }
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="assocCheckbox"
                        checked={assocCheckedItems.includes(associate.id)}
                        onChange={(e) =>
                          checkItem(e.target.checked, associate.id)
                        }
                      />
                    </div>
                    <div
                      className=""
                      onClick={() => sidebarHandler(associate.id)}
                    >
                      <img
                        className="img-responsive rounded-circle border"
                        style={{ width: '45px', height: '45px' }}
                        src={
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop
                          e.target.src = placeholderImage;
                        }}
                      />
                    </div>
                    <div onClick={() => sidebarHandler(associate.id)}>
                      <p className="fs-6 fw-medium">
                        {associate.last_name_first
                          ? `${associate.last_name} ${associate.first_name}`
                          : `${associate.first_name} ${associate.last_name}`}{' '}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
            {/* Button Img */}
          </div>
        </div>
      </div>
    ) : loading == true && gettingData == true ? (
      <div className="springloader-holder">
        {/* <SpringLoader></SpringLoader> */}
      </div>
    ) : (
      <div className="text-center text-muted my-3 pb-4">
        <i>No results</i>
      </div>
    );

  return (
    <React.Fragment>
      {body}
      <AssociateSidebar
        sites={sites}
        activeShift={activeShift}
        activeDate={activeDate}
        activeSchedules={activeSchedules}
        activeSchedule={activeSchedule}
        activeClient={activeClient}
        activeSite={activeSite}
        activeWeek={activeWeek}
        activeSidebar={activeSidebar}
        fetchSchedules={fetchSchedules}
        sidebarMultiAssoc={sidebarMultiAssoc}
        sidebarMultiAssocLeaves={sidebarMultiAssocLeaves}
        setActiveSidebar={setActiveSidebar}
        setSidebarMultiAssoc={setSidebarMultiAssoc}
        setSidebarMultiAssocLeaves={setSidebarMultiAssocLeaves}
        siteAssociateLeaves={siteAssociateLeaves}
        associate={associate}
        statuses={statuses}
        assocToEdit={assocToEdit}
        activeStatus={activeStatus}
        selectedAssociate={selectedAssociate}
      />
    </React.Fragment>
  );
};

export default Associates;
